import { createTheme } from "@mantine/core";

export const baseApi =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:8080'
    : 'https://api.smartsoftek.com';

export const website = {
  home: {
    hero: [
      { name: 'title', type: 'shortText' },
      { name: 'description', type: 'longText' },
      { name: 'image', type: 'image' },
      { name: "link", type: "link"},
    ],
    services: [
        { name: "title", type: "shortText" },
        {
          name: "cards",
          type: "array",
          items: [
            {name: "title", type: "shortText"},
            {name: "description", type: "longText"},
            {name: "icon", type: "image"}
          ]
        }
    ],
  },
  about: {
    main: [{ name: 'content', type: 'longText' }],
    team: [{ name: 'teamPhoto', type: 'image' }],
  },
    // ... other pages
};
export const theme = createTheme({
    fontFamily: 'Arabic',
    // colorScheme: 'light', 
    headings: {fontFamily: 'Roboto, sans-serif', sizes: {h1: { fontSize: '2rem' },},},
    components:{
      Tabs:{
        styles: {
          list:{
            borderLeftWidth: '2rem',
          },
        },
      },
    },
    colors: {
      andrew: ["#ffede4","#ffdbcd","#ffb69b","#ff8e64","#fe6d37","#fe571a","#ff4c09","#e43c00","#cb3400","#b12900"],
      appBlue: ["#edf1fc","#d8dff3","#adbde9","#8098e0","#5b79d9","#4466d6","#385dd5","#2c4dbc","#2444a9","#183a95"],
      andrew2: ['#FFF4E6', '#FFF4E6', '#FFF4E6', '#FFF4E6', '#FFF4E6', '#FFF4E6', '#FF4500', '#FFF4E6', '#FFF4E6', '#FFF4E6'],
      stg: 	 ["#ffecee","#f8d6da","#efabb2","#e67d87","#de5663","#db3e4c","#da3140","#c12432","#ad1d2c","#981224"],
      // ksa: 	 ["#ffe9eb","#ffd2d3","#f9a2a5","#f47074","#ef454a","#ed2b30","#ed1b21","#d30e15","#bd0412","#a6000c"],
      ss: 	 [
        "#ffe9eb","#ffd2d3","#f9a2a5","#f47074","#ef454a",
        "#ed2b30","#093eff","#0031e4","#002AD2","#020A6D"],
      // ksaB: 	 ["#eff0ff","#dcdcf3","#b5b6e4","#8c8ed4","#6a6cc7","#5457c1","#494bbe","#3a3da8","#333697","#292d86"]
    },
  })
let id = 0
export const getId = () => { return id }
export const setId = (d:number) => { id = d }
export const languages = [
  { code: 'ar', name: 'العربية', flag: '/flags/ar.webp' },
  { code: 'en', name: 'English', flag: '/flags/en.webp' },
  // { code: 'fr', name: 'Français', flag: '/flags/fr.webp' },
  // { code: 'es', name: 'Español', flag: '/flags/es.webp' },
  // { code: 'ru', name: 'Русский', flag: '/flags/ru.webp' },
  // { code: 'de', name: 'Deutsch', flag: '/flags/de.webp' },
  // { code: 'it', name: 'Italiano', flag: '/flags/it.webp' },
  // { code: 'zh', name: '中文', flag: '/flags/cn.webp' },
  // { code: 'tr', name: 'Türkçe', flag: '/flags/tr.webp' },
  // { code: 'hi', name: 'हिंदी', flag: '/flags/in.webp' },
];
export type LanguageSelector = {
    code: string;
    name: string;
    flag: string;
};
export const availableLanguages = languages.map((lang) => lang.code);

export const navTranslations: { [key: string]: { [key: string]: string } } = {
  ar: {
    home: "سمارت سوفتك",
    services: "الخدمات",
    webApps: "تطبيقات الويب",
    websites: "المواقع الإلكترونية",
    mobileApps: "تطبيقات الهاتف المحمول",
    iot: "إنترنت الأشياء",
    electronics: "الإلكترونيات",
    mixedSolutions: "حلول مختلطة",
    aboutUs: "من نحن",
    ourStory: "قصتنا",
    sustainability: "الاستدامة",
    careers: "انضم إلينا",
    contactUs: "اتصل بنا",
    login: "تسجيل الدخول",
    logout: "تسجيل الخروج",
  },
  en: {
    home: "Samrt Softek",
    services: "Services",
    webApps: "Web Apps",
    websites: "Websites",
    mobileApps: "Mobile Apps",
    iot: "IoT",
    electronics: "Electronics",
    mixedSolutions: "Mixed Solutions",
    aboutUs: "About Us",
    ourStory: "Our Story",
    sustainability: "Sustainability",
    careers: "Careers",
    contactUs: "Contact Us",
    login: "Login",
    logout: "Logout",
  },
  // fr: {
  //   home: "Accueil",
  //   services: "Services",
  //   webApps: "Applications Web",
  //   websites: "Sites Web",
  //   mobileApps: "Applications Mobiles",
  //   iot: "IoT",
  //   electronics: "Électronique",
  //   mixedSolutions: "Solutions Mixtes",
  //   aboutUs: "À Propos",
  //   ourMission: "Notre Mission",
  //   ourVision: "Notre Vision",
  //   joinUs: "Rejoignez-nous",
  //   environment: "Environnement",
  //   contactUs: "Contactez-nous",
  //   login: "Connexion",
  //   logout: "Déconnexion",
  // },
  // es: {
  //   home: "Inicio",
  //   services: "Servicios",
  //   webApps: "Aplicaciones Web",
  //   websites: "Sitios Web",
  //   mobileApps: "Aplicaciones Móviles",
  //   iot: "IoT",
  //   electronics: "Electrónica",
  //   mixedSolutions: "Soluciones Mixtas",
  //   aboutUs: "Sobre Nosotros",
  //   ourMission: "Nuestra Misión",
  //   ourVision: "Nuestra Visión",
  //   joinUs: "Únete a Nosotros",
  //   environment: "Medio Ambiente",
  //   contactUs: "Contáctanos",
  //   login: "Iniciar sesión",
  //   logout: "Cerrar sesión",
  // },
  // ru: {
  //   home: "Главная",
  //   services: "Услуги",
  //   webApps: "Веб-приложения",
  //   websites: "Веб-сайты",
  //   mobileApps: "Мобильные приложения",
  //   iot: "Интернет вещей",
  //   electronics: "Электроника",
  //   mixedSolutions: "Смешанные решения",
  //   aboutUs: "О нас",
  //   ourMission: "Наша миссия",
  //   ourVision: "Наше видение",
  //   joinUs: "Присоединяйтесь к нам",
  //   environment: "Окружающая среда",
  //   contactUs: "Свяжитесь с нами",
  //   login: "Войти",
  //   logout: "Выйти",
  // },
  // de: {
  //   home: "Startseite",
  //   services: "Dienstleistungen",
  //   webApps: "Web-Apps",
  //   websites: "Websites",
  //   mobileApps: "Mobile Apps",
  //   iot: "IoT",
  //   electronics: "Elektronik",
  //   mixedSolutions: "Gemischte Lösungen",
  //   aboutUs: "Über Uns",
  //   ourMission: "Unsere Mission",
  //   ourVision: "Unsere Vision",
  //   joinUs: "Mitmachen",
  //   environment: "Umwelt",
  //   contactUs: "Kontaktieren Sie uns",
  //   login: "Anmelden",
  //   logout: "Abmelden",
  // },
  // it: {
  //   home: "Home",
  //   services: "Servizi",
  //   webApps: "App Web",
  //   websites: "Siti Web",
  //   mobileApps: "App Mobili",
  //   iot: "IoT",
  //   electronics: "Elettronica",
  //   mixedSolutions: "Soluzioni Miste",
  //   aboutUs: "Chi Siamo",
  //   ourMission: "La Nostra Missione",
  //   ourVision: "La Nostra Visione",
  //   joinUs: "Unisciti a Noi",
  //   environment: "Ambiente",
  //   contactUs: "Contattaci",
  //   login: "Accedi",
  //   logout: "Esci",
  // },
  // zh: {
  //   home: "首页",
  //   services: "服务",
  //   webApps: "网络应用",
  //   websites: "网站",
  //   mobileApps: "移动应用",
  //   iot: "物联网",
  //   electronics: "电子产品",
  //   mixedSolutions: "混合解决方案",
  //   aboutUs: "关于我们",
  //   ourMission: "我们的使命",
  //   ourVision: "我们的愿景",
  //   joinUs: "加入我们",
  //   environment: "环境",
  //   contactUs: "联系我们",
  //   login: "登录",
  //   logout: "登出",
  // },
  // tr: {
  //   home: "Ana Sayfa",
  //   services: "Hizmetler",
  //   webApps: "Web Uygulamaları",
  //   websites: "Web Siteleri",
  //   mobileApps: "Mobil Uygulamalar",
  //   iot: "IoT",
  //   electronics: "Elektronik",
  //   mixedSolutions: "Karma Çözümler",
  //   aboutUs: "Hakkımızda",
  //   ourMission: "Misyonumuz",
  //   ourVision: "Vizyonumuz",
  //   joinUs: "Bize Katılın",
  //   environment: "Çevre",
  //   contactUs: "İletişim",
  //   login: "Giriş Yap",
  //   logout: "Çıkış Yap"
  // },
  // hi: {
  //   home: "होम",
  //   services: "सेवाएं",
  //   webApps: "वेब ऐप्स",
  //   websites: "वेबसाइट्स",
  //   mobileApps: "मोबाइल ऐप्स",
  //   iot: "आईओटी",
  //   electronics: "इलेक्ट्रॉनिक्स",
  //   mixedSolutions: "मिश्रित समाधान",
  //   aboutUs: "हमारे बारे में",
  //   ourMission: "हमारा मिशन",
  //   ourVision: "हमारा दृष्टिकोण",
  //   joinUs: "हमसे जुड़ें",
  //   environment: "पर्यावरण",
  //   contactUs: "संपर्क करें",
  //   login: "लॉग इन करें",
  //   logout: "लॉग आउट करें",
  // },
};
export const textVariant = (delay: number) => {
  return {
    hidden: {
      y: -50,
      opacity: 0,
    },
    show: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        duration: 1.25,
        delay: delay,
      },
    },
  };
};

export const fadeIn = (direction: string, type: any, delay: any, duration: any) => {
  return {
    hidden: {
      x: direction === "left" ? 100 : direction === "right" ? -100 : 0,
      y: direction === "up" ? 100 : direction === "down" ? -100 : 0,
      opacity: 0,
    },
    show: {
      x: 0,
      y: 0,
      opacity: 1,
      transition: {
        type: type,
        delay: delay,
        duration: duration,
        ease: "easeOut",
      },
    },
  };
};

// export const zoomIn = (delay, duration) => {
//   return {
//     hidden: {
//       scale: 0,
//       opacity: 0,
//     },
//     show: {
//       scale: 1,
//       opacity: 1,
//       transition: {
//         type: "tween",
//         delay: delay,
//         duration: duration,
//         ease: "easeOut",
//       },
//     },
//   };
// };

export const slideIn = (direction: string, type: any, delay: any, duration: any) => {
  return {
    hidden: {
      x: direction === "left" ? "-100%" : direction === "right" ? "100%" : 0,
      y: direction === "up" ? "100%" : direction === "down" ? "100%" : 0,
    },
    show: {
      x: 0,
      y: 0,
      transition: {
        type: type,
        delay: delay,
        duration: duration,
        ease: "easeOut",
      },
    },
  };
};

export const staggerContainer = (staggerChildren: any, delayChildren: any) => {
  return {
    hidden: {},
    show: {
      transition: {
        staggerChildren: staggerChildren,
        delayChildren: delayChildren || 0,
      },
    },
  };
};

/*
    I need to reevaluate the structure of the website menus to make sure that the website is structured in a way that is easy to navigate.

    I have 3 categories of menu groups

    A) Groups Without Login

    Group 1: Home (no children)
    Group 2: Services (6 children)
    1) webApps
    2) websites
    3) mobileApps
    4) iot
    5) electronics
    6) mixedSolutions

    Group 3: About Us (4 children)
    1) Our Mission
    2) Our Vision
    3) Join Us
    4) Environment

    Group 4: Contact Us (no children)
    
    B) Groups With User Login (for my customers to monitor the work progress and payments and due dates and all what makes my business better and maybe not in my mind now)
    Group 5: Customer (n children)
    1) Dashboard
    2) Projects
    3) Payments
    4) Due Dates
    5) Messages
    ... and more

    (or a dedicated dashboard for the customers to manage the projects and the payments and the due dates and the messages)

    C) Groups With Admin Login (My Dashboard to manage the website and the customers and the projects and the payments and the due dates and the messages)
    I whish that I can see a didcated dashboard for the admin to manage the website and the customers and the projects and the payments and the due dates and the messages

    before coding can you brain storm through this idea and if my arrangement of the menus (specially in the first menu group) is good or not and if you have any suggestions to make the website more user friendly and more easy to navigate please let me know
   

Main Navigation (Shared Across Roles)
- Home  
- Services  
    - Digital Solutions  
        - Web Apps  
        - Websites  
        - Mobile Apps  
    - Engineering Solutions  
        - IoT  
        - Electronics  
        - Mixed Solutions  
- About Us  
    - Our Story  
    - Careers  
    - Sustainability  
- Contact Us  

Logged-In Users
- Dashboard  
    - Overview  
    - Projects  
    - Payments  
    - Due Dates  
    - Messages  
    - Reports  

Admins
- Dashboard  
    - Manage Users  
    - Manage Projects  
    - Payments Overview  
    - Notifications  
    - Settings 
    */